// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".episodes-row[data-v-5a93a830]{display:flex;justify-content:flex-start;gap:16px;padding-top:4px;max-width:100%}", ""]);
// Exports
module.exports = exports;
